import { $api } from '@shared/api';
import { IReturnResponse } from '@widgets/Files/model/types/api.interface';
import { TFolderId } from '@widgets/Files/model/types/folderId.type';

// $api.interceptors.response.use(
//     (resp) => resp.data,
//     (err) => {
//         const msg = err.response?.data?.message ?? err.message;
//         return Promise.reject(new Error(msg));
//     }
// );

export const deleteFolder = async (folderId: TFolderId): Promise<IReturnResponse> => {
    // @ts-ignore
    const route = routable.getRoute('deleteFolder').replace('_folderId_', folderId);
    try {
        const { data } = await $api.post<IReturnResponse>(route);
        return data;
    } catch (error: any) {
        console.error('deleteFolder failed:', error);
        return {
            status: 'error',
            data: null,
            message: error.message,
        };
    }
};
